module.exports = __webpack_public_path__ + "static/media/brandingPhone.77c52263.webp";